import styled from "styled-components";
import bg from "assets/images/bg-green.jpg";
import photo from "assets/images/CW__3111.jpg";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: #142723 url(${bg}) repeat center center;
  background-size: contain;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 44px 96px;
  column-gap: 32px;
  position: relative;

  animation-name: appear;
  animation-duration: 500ms;
  animation-timing-function: ease;
  animation-direction: alternate;

  @keyframes appear {
    0% {
      transform: skew(-10deg) translate3d(-10vw, 0px, 0px);
    }
    100% {
      transform: skew(0deg) translate3d(0, 0px, 0px);
    }
  }

  @media screen and (max-width: 580px) {
    padding: 0;
  }
`;

export const Wrapper = styled.div`
  position: relative;

  @media screen and (max-width: 580px) {
    width: 100%;
    height: 100vh;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 88px);
  width: max-content;
  border-radius: 24px;
  overflow: hidden;

  @media screen and (max-width: 580px) {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    background: url(${photo}) no-repeat center center;
    background-size: cover;
  }
`;

export const Photo = styled.img.attrs({ src: photo })`
  width: auto;
  max-width: max-content;
  height: auto;
  max-height: calc(100vh - 88px);

  @media screen and (max-width: 580px) {
    display: none !important;
  }
`;

export const Credit = styled.article`
  width: 100%;
  max-width: 200px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  bottom: 48px;
  left: -45%;

  @media screen and (max-width: 1152px) {
    left: 32px;
    bottom: 32px;
    font-size: 12px;
    line-height: 16px;
  }
`;
